<template>
    <div class="clipboard">
        <div class="clipboard-head">
            <div class="flex-center">
                <input v-model="file_name" class="clipboard-input" type="text">
                <div class="clipboard-btn">
                    <VButton
                        @clickHandler="$emit('convertToBlob', canvasEl, file_name)"
                        active
                    >Upload</VButton>
                    <VButton
                        @clickHandler="$parent.$parent.$refs['clipboard-modal'].hideModal()"
                    >Cancel</VButton>
                </div>
            </div>
            <div class="clipboard-controllers">
                <button v-for="element in elements" @click="selectElement(element)" :class="[{'active': activeElement === element.id }]">
                    <div v-if="element.type === 'text'" :style="{ color: element.color }" :class="[`clipboard__text-${element.contentSize}`]">Aa</div>
                    <div v-else :style="{ backgroundColor: element.color }" :class="[`clipboard__brash-${element.contentSize}`, 'brash']"></div>

                    <div v-if="element.showColors" class="clipboard__colors" >
                        <button v-for="(color, index) in colors" @click="selectElementColor(color, element)">
                            <div
                                class="clipboard__field"
                                :key="index"
                                :style="{ backgroundColor: color }"
                            ></div>
                        </button>
                    </div>
                </button>
                <button @click="undo" style="width: auto">Undo</button>
                <button @click="redo" style="width: auto">Redo</button>

            </div>
            <div class="clipboard__copy-download">
                <VButton @clickHandler="copyImageToClipboard">
                    <i class="icon-clipboard-add"></i>
                    <span class="clipboard__text">Copy to Clipbaord</span>
                </VButton>
                <VButton @clickHandler="downloadImage">
                    <i class="icon-download-small"></i>
                    <span class="clipboard__text">download</span>
                </VButton>
            </div>
        </div>

        <div v-if="fileOpening" class="clipboard-loading">
            <LoaderAnimationVue color="#fff" />
            <p>Please wait, image is loading...</p>
        </div>
        <div class="clipboard-body" ref="clipboardBody">
            <img class="clipboard-image" ref="image" :src="clipboard_img" alt="">
            <canvas :width="canvasWidth" :height="canvasHeight" ref="canvas"></canvas>
        </div>
        <Flash ref="show"/>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton";
import Flash from "@/components/Flash.vue";
import { fabric } from 'fabric';
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";

export default {
    name: 'ImageEditor',
    components: { VButton, Flash, LoaderAnimationVue, },
    props: ['clipboard_img', 'clipboardImageName', 'fileOpening'],
    data() {
        return {
            canvasEl: null,
            file_name: this.clipboardImageName || '',

            canvas: null,
            canvasWidth: 300,
            canvasHeight: 300,
            isBrushMode: true,
            isTextMode: false,
            selectedColor: '#ff0000',
            brushSize: 5,
            textSize: 10,
            undoStack: [],
            redoStack: [],
            textDeactivated: false,

            elements: [
                { id: '1', type: 'text', color: '#ff0000', size: 15, contentSize: 'xs', showColors: false },
                { id: '2', type: 'text', color: '#ff0000', size: 25, contentSize: 'sm', showColors: false },
                { id: '3', type: 'text', color: '#ff0000', size: 40, contentSize: 'xl', showColors: false },
                { id: '4', type: 'brush', color: '#ff0000', size: 5 , contentSize: 'xs', showColors: false},
                { id: '5', type: 'brush', color: '#ff0000', size: 10, contentSize: 'md', showColors: false },
                { id: '6', type: 'brush', color: '#ff0000', size: 20, contentSize: 'xl', showColors: false }
            ],
            activeElement: '4',
            colors: ['#ff0000', '#ffffff', '#00ff00', '#0000ff', '#000000'],
        }
    },
    mounted() {
        setTimeout(() => {
            this.canvas = new fabric.Canvas(this.$refs.canvas, {
                selection: false,
            });

            this.canvas.isDrawingMode = this.isBrushMode;
            this.canvas.freeDrawingBrush.color = this.selectedColor;
            this.canvas.freeDrawingBrush.width = this.brushSize;
            this.canvas.on('path:created', () => {
                if (this.canvas._objects.length > 0) {
                    this.canvas._objects.map(obj => obj.text ? '' : obj.selectable = false)
                }
                this.addToUndoStack()
            });
            this.canvas.on('mouse:down', event => {
                if (this.isTextMode) {
                    const pointer = this.canvas.getPointer(event.e);

                    const objects = this.canvas.getObjects();
                    let canAddText = true;
                    objects.forEach((obj) => {
                        if (obj.text && obj.containsPoint(pointer)) {
                            canAddText = false;
                            return;
                        }
                    });

                    if (canAddText && !this.textDeactivated) {
                        this.addText(pointer.x, pointer.y,);
                    }

                    this.textDeactivated = false
                }
            });
            this.canvas.on('selection:cleared', () => this.textDeactivated = true);
            this.canvas.on('mouse:down', () => this.elements.forEach(element => element.showColors = false));
            this.$refs.clipboardBody.addEventListener('mousedown', () => this.elements.forEach(element => element.showColors = false))

            fabric.Image.fromURL(this.clipboard_img, (img) => {
                this.canvasWidth = this.$refs.image.width
                this.canvasHeight = this.$refs.image.height
                
                this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas), {
                    scaleX: this.canvasWidth / img.width,
                    scaleY: this.canvasHeight / img.height,
                });

                this.canvas.setDimensions({ width: this.canvasWidth, height: this.canvasHeight });

                this.canvasEl = document.querySelector('.lower-canvas')
            });

            document.addEventListener('keydown', event => {
                if ((event.ctrlKey || event.metaKey) && event.key == 'z') {
                    const activeObject = this.canvas.getActiveObject();
                    if (activeObject?.text) {
                        activeObject.exitEditing();
                        this.canvas.discardActiveObject();
                    }
                    this.undo()
                } else if ((event.ctrlKey || event.metaKey) && event.key == 'y') {
                    this.redo()
                }
            })
        }, 100)
    },
    methods: {
        selectElement(element) {
            this.activeElement = element.id
            
            if (element.showColors == false) {
                this.elements.forEach(el => el.showColors = false)
                element.showColors = true
            } else {
                element.showColors = false
            }

            if (element.type == 'text') {
                this.isTextMode = true
                this.isBrushMode = false

                this.textSize = element.size
                this.selectedColor = element.color

                this.canvas.isDrawingMode = false
                this.canvas.selection = true
            } else {
                this.isTextMode = false
                this.isBrushMode = true

                this.brushSize = element.size
                this.canvas.freeDrawingBrush.width = element.size
                this.selectedColor = element.color
                this.canvas.freeDrawingBrush.color = element.color

                this.canvas.isDrawingMode = true
                this.canvas.selection = false
            }
        },
        selectElementColor(color, element) {
            element.color = color
            this.selectedColor = color
            this.canvas.freeDrawingBrush.color = this.selectedColor
        },
        addText(left, top) {
            this.isBrushMode = false
            this.isTextMode = true

            const text = new fabric.IText('Type here', {
                left: left,
                top: top,
                fill: this.selectedColor,
                fontSize: this.textSize,
                hasControls: false
            });
            this.canvas.add(text);
            text.set({
                selectable: true,
            });

            text.enterEditing();
            text.selectAll();

            this.canvas.setActiveObject(text)
            this.canvas.isDrawingMode = false;
            this.addToUndoStack()
        },
        undo() {
            if (this.undoStack.length > 0) {
                this.redoStack.push(this.undoStack.pop())
                this.canvas._objects = [...this.undoStack]
                this.canvas.renderAll()
            }
        },
        redo() {
            if (this.redoStack.length > 0) {
                this.undoStack.push(this.redoStack.pop())
                this.canvas._objects = [...this.undoStack]
                this.canvas.renderAll();
            }
        },
        addToUndoStack() {
            this.undoStack = this.canvas._objects
            this.redoStack = [];
        },
        async copyImageToClipboard() {
            const canvas = this.canvasEl;
            const imageUrl = canvas.toDataURL('image/png');
            const imgElement = document.createElement('img');
            imgElement.src = imageUrl;

            const src = imgElement.src
            const base64Data = src.split(',')[1]
            const binaryData = atob(base64Data)
            const blob = new Blob([new Uint8Array(binaryData.length).map((_, i) => binaryData.charCodeAt(i))], { type: 'image/png' });

            navigator.clipboard.write([
                new ClipboardItem({ "image/png": blob })
            ]).then(() => {
                this?.$refs.show?.showFlashSuccess('Image copied to clipboard');
            }).catch((err) => {
                console.log(err?.message);
                this?.$refs.show?.showFlashError('Something went wrong');
            });
        },
        downloadImage() {
            const link = document.createElement('a');
            link.href = this.canvasEl.toDataURL('image/png');
            link.download = this.file_name;
            link.click();
        }
    }
}
</script>

<style lang="scss">
.clipboard {
    .clipboard-head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .flex-center {
        display: flex;
        align-items: center;
    }

    .clipboard-input {
        border-radius: 6px;
        border: 1px solid var(--outline);
        background: var(--primary-bg);
        color: var(--primary-text);
        width: 175px;
        height: 34px;
        flex-shrink: 0;
        margin-right: 10px;
        &:focus-visible {
            outline: none;
        }
    }

    .clipboard-btn {
        .btn {
            width: 83px;
            height: 31px;
            margin-right: 5px;
        }
    }

    .clipboard-image {
        max-height: 500px;
        min-width: 200px;
        margin: 0 auto;
        display: block;
        position: absolute;
        pointer-events: none;
        opacity: 0;
    }
    .clipboard-controllers {
        display: flex;
        align-items: center;
        gap: 5px;
    }
    & button {
        width: 27px;
        height: 27px;
        border-radius: 6px !important;
        background: var(--primary-bg);

        color: var(--primary-text);
        font-weight: 500;
        padding: 4px;
        border: 0.5px solid var(--outline);
        text-align: end;
        cursor: pointer;

        &:hover, &.active {
            outline: 2px solid #9BDBFF;
        }
    }

    &__field {
        border-radius: 4px;
        background-color: #fff;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    & .brash {
        border-radius: 50%;
        background: $brash-default;
        margin: 0 auto;
    }

    &__text-xs {
        font-size: 10px;
    }
    &__text-md {
        font-size: 14px;
    }
    &__text-xl {
        font-size: 16px;
    }
    &__brash-xs {
        width: 7px;
        height: 7px;
    }
    &__brash-md {
        width: 10px;
        height: 10px;
    }
    &__brash-xl {
        width: 13px;
        height: 13px;
    }

    &__copy-download {
        display: flex;
        align-items: center;
        gap: 5px;
        font-weight: 500;

        .btn {
            height: 31px;
        }

        i:before {
            display: block;
            font-size: 22px;
            margin-right: 5px;
        }
    }
    &__color {
        position: relative;
    }

    &__colors {
        display: flex;
        flex-direction: column;
        gap: 5px;
        position: absolute;
        left: 0;
        top: 32px;
        z-index: 1;
    }
    .clipboard-body {
        position: relative;
        margin-top: 5px;
        display: flex;
        justify-content: center;
        min-height: 120px;
    }
    .active {
        position: relative;
    }
}
.clipboard-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 10px 0;
}
</style>